import { render, staticRenderFns } from "./LabelManagement.vue?vue&type=template&id=ac5025ca&scoped=true&"
import script from "./LabelManagement.vue?vue&type=script&lang=js&"
export * from "./LabelManagement.vue?vue&type=script&lang=js&"
import style0 from "./LabelManagement.vue?vue&type=style&index=0&id=ac5025ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac5025ca",
  null
  
)

export default component.exports